var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6267_19183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2709 5.73397C16.2229 5.68583 16.1658 5.64764 16.103 5.62159C16.0402 5.59553 15.9729 5.58212 15.9049 5.58212C15.8369 5.58212 15.7695 5.59553 15.7067 5.62159C15.6439 5.64764 15.5868 5.68583 15.5388 5.73397L12.9998 8.26781L10.4607 5.72877C10.4127 5.6807 10.3556 5.64257 10.2928 5.61655C10.23 5.59054 10.1627 5.57715 10.0947 5.57715C10.0267 5.57715 9.95938 5.59054 9.89657 5.61655C9.83376 5.64257 9.77669 5.6807 9.72862 5.72877C9.68055 5.77685 9.64242 5.83391 9.6164 5.89672C9.59039 5.95953 9.577 6.02685 9.577 6.09483C9.577 6.16282 9.59039 6.23013 9.6164 6.29294C9.64242 6.35575 9.68055 6.41282 9.72862 6.46089L12.2677 8.99993L9.72862 11.539C9.68055 11.587 9.64242 11.6441 9.6164 11.7069C9.59039 11.7697 9.577 11.837 9.577 11.905C9.577 11.973 9.59039 12.0403 9.6164 12.1031C9.64242 12.1659 9.68055 12.223 9.72862 12.2711C9.77669 12.3192 9.83376 12.3573 9.89657 12.3833C9.95938 12.4093 10.0267 12.4227 10.0947 12.4227C10.1627 12.4227 10.23 12.4093 10.2928 12.3833C10.3556 12.3573 10.4127 12.3192 10.4607 12.2711L12.9998 9.73204L15.5388 12.2711C15.5869 12.3192 15.644 12.3573 15.7068 12.3833C15.7696 12.4093 15.8369 12.4227 15.9049 12.4227C15.9729 12.4227 16.0402 12.4093 16.103 12.3833C16.1658 12.3573 16.2229 12.3192 16.2709 12.2711C16.319 12.223 16.3571 12.1659 16.3831 12.1031C16.4092 12.0403 16.4226 11.973 16.4226 11.905C16.4226 11.837 16.4092 11.7697 16.3831 11.7069C16.3571 11.6441 16.319 11.587 16.2709 11.539L13.7319 8.99993L16.2709 6.46089C16.4682 6.26358 16.4682 5.93127 16.2709 5.73397Z",
    fill: "#E42125"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#E42125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6267_19183",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6267_19183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6267_19183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.89cafca8bd0fac029975167619ccc66d.svg";
export { ForwardRef as ReactComponent };